// @Copyright Highway9 Networks Inc. 2023-2024
import React, { Suspense, lazy } from 'react'
import './App.css'
import { Router, Route, Switch } from 'react-router-dom'
import { history } from './helpers'
import { theme as newTheme , ThemeProvider , ErrorBoundary} from "@h9/ui-lib";
import { AuthRouter } from "./navigation/AuthRouter"
import { SnackbarProvider } from 'notistack'
import { Loading } from './navigation/Loading'
import { AiAssistantProvider } from '@h9/ui-lib/components/organisms/AiAssistant'
import { useSaasAiAssistantAdapter } from './components/AiAssistantChat/adapter/saasAiAssistantAdapter'

const LoginPage = lazy(() => import('./navigation/LoginPage').then((m) => ({ default: m.LoginPage })))
const AppLoginPage = lazy(() => import('./navigation/AppLoginPage').then((m) => ({ default: m.AppLoginPage })))
const AppRoutes = lazy(() => import('./navigation/AppRoutes'))
const ResetPasswordPage = lazy(() => import('./navigation/ResetPasswordPage').then((m) => ({ default: m.ResetPasswordPage })))
const TNCPanel = lazy(() => import('./views/eula/TNCPanel'))
const VmcLogin = lazy(() => import('./navigation/VmcLogin').then((m) => ({ default: m.VmcLogin })))
const SmsAuthenticationDisclosure = lazy(() => import('./views/smsAuthentication/SmsAuthenticationDisclosure'))
const MobileZivaPage = lazy(() => import('./navigation/MobileZivaPage').then((m) => ({ default: m.MobileZivaPage })))

const App = () => {
    // One provider for the whole app: the assistant's toggle sits in the TopBar while the
    // panel sits in the layout and on the mobile route, so no single subtree contains them.
    const aiAssistant = useSaasAiAssistantAdapter()
    return (
        <ErrorBoundary>
            <ThemeProvider theme={newTheme}>
              <AiAssistantProvider adapter={aiAssistant}>
                    <SnackbarProvider
                        maxSnack={5}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        autoHideDuration={3000}
                    >
                        <Router history={history}>
                            <Suspense fallback={<Loading />}>
                            <Switch>
                                <Route exact path="/login" component={LoginPage} />
                                <Route exact path="/appLogin" component={AppLoginPage} />
                                {/* App-embedded ZIVA (MCS-3994): chrome-less, above AuthRouter so it
                                    bypasses the shell + login guard; auth comes from the injected token. */}
                                <Route exact path="/mobile/ziva" component={MobileZivaPage} />
                                <Route exact path="/vmcLogin" component={VmcLogin} />
                                <Route exact path="/resetPassword" component={ResetPasswordPage} />
                                <Route exact path="/eula" component={TNCPanel} />
                                <Route exact path="/sms-authentication-disclosure" component={SmsAuthenticationDisclosure} />
                                <AuthRouter path="/" component={AppRoutes} />
                            </Switch>
                            </Suspense>
                        </Router>
                    </SnackbarProvider>
              </AiAssistantProvider>
            </ThemeProvider>
        </ErrorBoundary>
    )
}
export default App